import {
	UPDATE_VIDEO_PROGRESS
} from './types'

export const updateVideoProgress = (payload) => async (dispatch) => {
	dispatch({
		type: UPDATE_VIDEO_PROGRESS,
		payload
	})
}